/* eslint-disable react-refresh/only-export-components */
import React from 'react';
import type {TableProps} from 'antd/lib/table';
import {QCTaskDetailSubheaderRow, QCTaskRow} from './types';
import {SUBHEADER_KINDS} from './constants';
import {CellElement, RowElement} from '../common/tableComponents';

export const TableElement: React.FC<
  React.TableHTMLAttributes<HTMLTableElement>
> = ({ style, children, ...rest }) => {
  const baseStyle: React.CSSProperties = {
    borderCollapse: 'collapse',
    borderSpacing: 0,
    tableLayout: 'fixed',
    width: '100%',
  };

  const mergedStyle = style ? { ...style, ...baseStyle } : baseStyle;

  const childArray = React.Children.toArray(children);
  const hasThead = childArray.some(
    child => React.isValidElement(child) && child.type === 'thead'
  );

  if (hasThead) {
    return (
      <table {...rest} style={mergedStyle}>
        {children}
      </table>
    );
  }

  return (
    <table {...rest} style={mergedStyle}>
      <thead
        style={{
          position: 'absolute',
          width: 1,
          height: 1,
          padding: 0,
          margin: -1,
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          border: 0,
        }}
      >
        <tr>
          <th scope='col'>QC tasks</th>
        </tr>
      </thead>
      {children}
    </table>
  );
};

export const isDetailSubheader = (
  row: QCTaskRow
): row is QCTaskDetailSubheaderRow => {
  if (row.type !== 'detail') {
    return false;
  }

  return (SUBHEADER_KINDS as readonly (typeof row.detailKind)[]).includes(
    row.detailKind
  );
};

export const components: TableProps<QCTaskRow>['components'] = {
  table: TableElement,
  body: { row: RowElement, cell: CellElement },
};

export const rowClassName = (row: QCTaskRow) => {
  if (row.type === 'group') {
    return '';
  }

  return isDetailSubheader(row) ? 'detail-subheader' : 'bg-transparent';
};

export const onRow: NonNullable<TableProps<QCTaskRow>['onRow']> = row => {
  if (row.type === 'group') {
    return { className: 'group-row' };
  }

  return {
    className: isDetailSubheader(row)
      ? 'detail-row detail-subheader'
      : 'detail-row',
  };
};
